import { useMemo, useState } from "react";
import { Box, Button, Collapse, Typography } from "@mui/material";
import { GovHistoryEntry } from "../../../../utils/icGovernance";
import { dateTime } from "../governanceStatus";
import SideCard from "./SideCard";
import { FAINT, MUTED, MONO, TEXT } from "./ui";

const time = (iso: string) => new Date(iso).getTime() || 0;

/**
 * The item's log, newest first: "{timestamp}  {actor} {text}". Expanded by
 * default (user decision 2026-10-10: logs must be visible in Thrive).
 */
const HistorySection = ({ history }: { history: GovHistoryEntry[] }) => {
  const [open, setOpen] = useState(true);
  const rows = useMemo(() => [...(history ?? [])].sort((a, b) => time(b.at) - time(a.at)), [history]);

  return (
    <SideCard
      title={`History (${rows.length})`}
      action={
        rows.length > 0 ? (
          <Button
            size="small"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
            sx={{ textTransform: "none", color: MUTED, minHeight: 36 }}
          >
            {open ? "Collapse" : "Expand"}
          </Button>
        ) : null
      }
    >
      {rows.length === 0 ? (
        <Typography variant="body2" sx={{ color: FAINT }}>
          No history yet
        </Typography>
      ) : (
        <Collapse in={open}>
          <Box component="ol" sx={{ listStyle: "none", m: 0, p: 0 }}>
            {rows.map((h, i) => (
              <Box
                component="li"
                key={h.id || `${h.at}-${i}`}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  columnGap: 2,
                  py: 0.75,
                  borderTop: i === 0 ? "none" : "1px solid #f3f3f5",
                }}
              >
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ fontFamily: MONO, color: FAINT, flexShrink: 0, minWidth: { sm: 180 }, pt: { sm: "2px" } }}
                >
                  {dateTime(h.at)}
                </Typography>
                <Typography component="span" variant="body2" sx={{ color: TEXT, overflowWrap: "anywhere" }}>
                  <b>{h.actor || "Someone"}</b> {h.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Collapse>
      )}
    </SideCard>
  );
};

export default HistorySection;
